export function slideDown(element, duration = 500, animateOpacity = false) {

    // Store original display once
    if (!element.dataset.originalDisplay) {

        const computedDisplay = getComputedStyle(element).display;

        element.dataset.originalDisplay =
            computedDisplay === 'none'
                ? 'block'
                : computedDisplay;
    }

    const originalDisplay = element.dataset.originalDisplay;

    element.style.display = originalDisplay;
    element.style.overflow = "hidden";
    element.style.height = "0px";

    if (animateOpacity) {
        element.style.opacity = "0";
    }

    const endHeight = element.scrollHeight;

    requestAnimationFrame(() => {

        const startTime = performance.now();

        function animate(currentTime) {

            element.style.overflowY = "hidden";

            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);

            element.style.height = progress * endHeight + "px";

            if (animateOpacity) {
                element.style.opacity = progress;
            }

            if (progress < 1) {

                requestAnimationFrame(animate);

            } else {

                element.style.height = "";
                element.style.overflow = "";
                element.style.overflowY = "auto";
                element.style.overflowX = "hidden";

                if (animateOpacity) {
                    element.style.opacity = "";
                }

                element.classList.add('slide-open');
            }
        }

        requestAnimationFrame(animate);
    });
}

export function slideUp(element, duration = 500, animateOpacity = false) {
    element.style.overflow = "hidden";
    let startHeight = element.scrollHeight;

    if (animateOpacity) {
        element.style.opacity = "1"; // Ensure it's fully visible
    }

    requestAnimationFrame(() => {
        let startTime = performance.now();

        function animate(currentTime) {
            let elapsedTime = currentTime - startTime;
            let progress = Math.min(elapsedTime / duration, 1);

            element.style.height = (1 - progress) * startHeight + "px";

            if (animateOpacity) {
                element.style.opacity = 1 - progress; // Decrease opacity if enabled
            }

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                element.style.display = "none";
                element.classList.remove('slide-open');
                element.style.height = "";
                if (animateOpacity) {
                    element.style.opacity = "";
                }
            }
        }

        requestAnimationFrame(animate);
    });
}


